/**
 * @generated SignedSource<<e912ebd21fdf26443f5dfeb7afa9c4e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WaitlistModalFragment_Facility$data = {
  readonly agendas: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly queueSlot: {
          readonly id: string;
        };
        readonly waitlistRestrictions: {
          readonly edges: ReadonlyArray<{
            readonly liftAt: string | null | undefined;
            readonly node: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "WaitlistModalFragment_Facility";
};
export type WaitlistModalFragment_Facility$key = {
  readonly " $data"?: WaitlistModalFragment_Facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"WaitlistModalFragment_Facility">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "date"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WaitlistModalFragment_Facility",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateGte",
          "variableName": "date"
        },
        {
          "kind": "Variable",
          "name": "dateLte",
          "variableName": "date"
        }
      ],
      "concreteType": "AgendaConnection",
      "kind": "LinkedField",
      "name": "agendas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "QueueSlot",
                  "kind": "LinkedField",
                  "name": "queueSlot",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": "waitlistRestrictions",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "type",
                      "value": [
                        "WAITLIST"
                      ]
                    }
                  ],
                  "concreteType": "AgendaBookingRulesConnection",
                  "kind": "LinkedField",
                  "name": "bookingRules",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AgendaBookingRulesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "liftAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v0/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "a2af5461b1791331daee71599e789a9b";

export default node;
